package com.nonopn.skydome.common.app.pages.main.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.pages.main.model.FakeMainScreenModel
import com.nonopn.skydome.common.app.pages.main.model.MainScreenModel
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.admin_map_group_mode_stop
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.CustomOutlinedButton
import eu.codlab.compose.widgets.TextNormal

@Composable
fun MapGroupingActions(
    modifier: Modifier,
    model: MainScreenModel
) {
    val color = defaultCardBackground()
    val state by model.states.collectAsState()

    if (!state.startGroupingCircles) return

    DefaultCard(
        modifier = modifier,
        backgroundColor = color,
        columnModifier = Modifier
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Column(Modifier.weight(1.0f)) { }

            CustomOutlinedButton(
                onClick = {
                    model.stopGroupingProbes()
                }
            ) {
                TextNormal(
                    text = Res.string.admin_map_group_mode_stop.localized()
                )
            }
            Column(Modifier.weight(1.0f)) { }
        }

        TextNormal("DevOnly", fontStyle = FontStyle.Italic)
    }
}

@Composable
@HotPreview(widthDp = 250, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 250, heightDp = 50, darkMode = false)
private fun MapDateSelection() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        MapDateSelection(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(false)
        )
    }
}
